import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, useNavigate } from "react-router-dom"; // ✅ Import useNavigate
import AppRoute from "./routes/AppRoute";
import MaintenancePage from "./components/maintenancePage";
import { handleAPIRequest } from "./api/api";
import { setMaintenanceStatus } from "./redux/authSlice";
function App() {
  return (
    <BrowserRouter> {/* ✅ Wrap the whole App in BrowserRouter */}
      <AppContent />
    </BrowserRouter>
  );
}

function AppContent() {
  
  const dispatch = useDispatch();
  const navigate = useNavigate(); // ✅ Initialize navigate
  const { role, maintenanceStatus } = useSelector((state) => state.auth);

  const checkMStatus = async () => {
    try {
      const response = await handleAPIRequest("get", "mstatus", null, null, null);
      if (response) {
        dispatch(setMaintenanceStatus(response)); // Store in Redux
      }
    } catch (error) {
      console.error("Something went wrong while checking maintenance status.");
    }
  };

  useEffect(() => {
    checkMStatus(); // Fetch maintenance status on mount

    // Poll every 5 seconds to check for maintenance status updates
    const interval = setInterval(checkMStatus, 5000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // Detect user interactions and navigate if maintenance mode is enabled
  useEffect(() => {
    const handleClick = () => {
      if (maintenanceStatus === "yes" && role !== "super_admin") {
        navigate("/maintenance"); // ✅ Navigate instead of using window.location.href
      }
    };

    document.addEventListener("click", handleClick);

    return () => document.removeEventListener("click", handleClick);
  }, [maintenanceStatus, role, navigate]);

  // If maintenance mode is enabled, show the maintenance page
  if (maintenanceStatus === "yes" && role !== "super_admin") {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      <AppRoute />
    </div>
  );
}

export default App;
